// import { Modal } from 'react-bootstrap-v5'
import { DataService } from './dataService'

const EnquiryService = {
    getEnquiryapi: async (data) => {
        return DataService.get('/admin/get_pending_quotes', data)
    },
    getEnquiryapiById: async (params) => {
        return DataService.get(`/admin/get_pending_quotes?quote_status=${params.quote_status}&quote_token=${params.quote_token}`)
    },

    Quotesignup: async (data) => {
        return DataService.post('/user/quote_sign_up', data)
    },
    // code for chek email exist or not
    checkEmailApi: async (data) => {
        return DataService.get('/admin/check_email', data)
    },

    postAirQuote: async (data) => {
        return DataService.post('/admin/get_air_quotes', data)
    },

    postSeaQuote: async (data) => {
        return DataService.post('/admin/get_sea_quotes', data)
    },
    postCourierQuote: async (data) => {
        return DataService.post('/admin/get_courier_quote', data)
    },

    postLandQuote: async (data) => {
        return DataService.post('/admin/get_land_quote', data)
    },

    /// re_quote

    postAirReQuote: async (data) => {
        return DataService.post('/admin/update_air_quotes', data)
    },

    postSeaReQuote: async (data) => {
        return DataService.post('/admin/update_sea_quotes', data)
    },
    postCourierReQuote: async (data) => {
        return DataService.post('/admin/update_courier_quote', data)
    },

    postLandReQuote: async (data) => {
        return DataService.post('/admin/update_land_quote', data)
    },

    /// check
    postCheckAirQuote: async (data) => {
        return DataService.post('/check/get_air_quotes', data)
    },

    postCheckSeaQuote: async (data) => {
        return DataService.post('/check/get_sea_quotes', data)
    },

    postCheckCourierQuote: async (data) => {
        return DataService.post('/check/get_courier_quote', data)
    },

    postCheckLandQuote: async (data) => {
        return DataService.post('/check/get_land_quote', data)
    },

    productReferralCode: async (data) => {
        return DataService.post('/admin/check_retailer_token', data)
    },

    productPromoCode: async (data) => {
        return DataService.post('/admin/check_promo_code', data)
    },

    /// delete Enquiery 

    deleteEnquiry: async (data) => {
        return DataService.post('/admin/delete_quote', data)
    },

    cancelEnquiry: async (data) => {
        return DataService.post('/admin/cancel_quote', data)
    },

    postSelectedCourier: async (data) => {
        return DataService.post('/admin/selected_courier_type', data)
    },


    //// updatePacking

    updatePackingApi: async (data) => {
        return DataService.post('/admin/add_update_packing', data)
    },

    /// api for follow up
    saveToFollowUpAPi: async (data) => {
        return DataService.post('/admin/setInsuranceAndStorage', data)
    },

    // find customer
    findCustomerApi: async (data) => {
        return DataService.get('/admin/check_email', data)
    },
    getQuoteToken: async (data) => {
		return DataService.get('/get_quote_token', data)
	},

}

export default EnquiryService;